import { useQuery, useQueryClient } from '@tanstack/react-query';
import { DashboardShell } from '@/components/layout/DashboardShell';
import { ClassTransferPanel } from '@/components/admin/ClassTransferPanel';
import { adminService } from '@/services/admin';
import type { StudentRecord, ClassSummary } from '@/types';

export default function AdminClassTransferPage() {
  const queryClient = useQueryClient();
  const { data: students = [] } = useQuery<StudentRecord[]>({
    queryKey: ['admin-students'],
    queryFn: adminService.listStudents,
  });
  const { data: classes = [] } = useQuery<ClassSummary[]>({
    queryKey: ['admin-classes'],
    queryFn: adminService.listClasses,
  });

  return (
    <DashboardShell title="Class assignment" role="admin">
      <ClassTransferPanel
        intro="Nothing is saved until you confirm. Registration numbers do not change. Left students are not listed."
        students={Array.isArray(students) ? students : []}
        classes={Array.isArray(classes) ? classes : []}
        onConfirm={async (studentIds, classId) => {
          await adminService.bulkAssignStudents({ studentIds, classId });
          queryClient.invalidateQueries({ queryKey: ['admin-students'] });
          queryClient.invalidateQueries({ queryKey: ['admin-classes'] });
          queryClient.invalidateQueries({ queryKey: ['admin-overview'] });
        }}
      />
    </DashboardShell>
  );
}
